
import React from 'react';
import { Button } from '@/components/ui/button';
import { Building, Phone } from 'lucide-react';
import { BackgroundOption } from '../data/backgroundOptions';

interface AgencySectionProps {
  currentBg: BackgroundOption;
}

const AgencySection: React.FC<AgencySectionProps> = ({ currentBg }) => {
  return (
    <div className="rounded-lg overflow-hidden shadow-lg">
      <div 
        className={`relative p-8 ${currentBg.textColor}`}
        style={{ 
          ...currentBg.style,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute top-0 left-0 w-full h-full bg-black/10 backdrop-blur-sm z-0"></div>
        
        <div className="relative z-10">
          <div className="flex items-center gap-2 mb-4">
            <Building className={`h-8 w-8 ${currentBg.iconColor}`} />
            <h3 className="text-xl font-bold">Are you an agency or franchise?</h3>
          </div>
          
          <p className="mb-6 opacity-90">
            Contact us to upgrade your account and get discounts on managing multiple businesses, 
            white labeling, and access to additional premium features tailored for agencies.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 items-center">
            <Button className={currentBg.buttonColor} onClick={() => window.open('mailto:support@example.com')}>
              Contact Sales
            </Button>
            <div className="flex items-center gap-2">
              <Phone className="h-5 w-5" />
              <span className="font-medium">Call us: (888) 555-1234</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgencySection;
